import { defineComponent as x, mergeModels as B, useModel as F, computed as u, useId as G, createBlock as I, openBlock as t, resolveDynamicComponent as k, mergeProps as C, unref as e, withCtx as m, createElementBlock as f, createCommentVNode as c, renderSlot as v, normalizeClass as d, createElementVNode as g, createVNode as b } from "vue";
import o from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Form/form.js";
import $ from "../Button.vue2.js";
import { AngleRightIcon as A } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { isDefined as P } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { useOUIAProps as h } from "../../helpers/ouia.js";
const L = /* @__PURE__ */ x({
  name: "PfFormFieldGroup",
  __name: "FormFieldGroup",
  props: /* @__PURE__ */ B({
    fieldset: { type: Boolean },
    expandable: { type: Boolean },
    toggleAriaLabel: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: void 0 },
    expandedModifiers: {}
  }),
  emits: ["update:expanded"],
  setup(n) {
    const r = n, y = h({ id: r.ouiaId, safe: r.ouiaSafe }), a = F(n, "expanded"), i = u(() => r.expandable || P(a.value)), s = u(() => `form-field-group-toggle-${G()}`);
    return (l, p) => (t(), I(k(l.fieldset ? "fieldset" : "div"), C(e(y), {
      class: [e(o).formFieldGroup, { [e(o).modifiers.expanded]: i.value && a.value }]
    }), {
      default: m(() => [
        i.value ? (t(), f("div", {
          key: 0,
          class: d(e(o).formFieldGroupToggle)
        }, [
          g("div", {
            class: d(e(o).formFieldGroupToggleButton)
          }, [
            b($, {
              id: s.value,
              variant: "plain",
              "aria-label": l.toggleAriaLabel,
              "aria-expanded": a.value,
              "aria-labelledby": s.value,
              onClick: p[0] || (p[0] = (E) => a.value = !a.value)
            }, {
              default: m(() => [
                g("span", {
                  class: d(e(o).formFieldGroupToggleIcon)
                }, [
                  b(e(A), { "aria-hidden": "" })
                ], 2)
              ]),
              _: 1
            }, 8, ["id", "aria-label", "aria-expanded", "aria-labelledby"])
          ], 2)
        ], 2)) : c("", !0),
        v(l.$slots, "header"),
        !i.value || a.value ? (t(), f("div", {
          key: 1,
          class: d(e(o).formFieldGroupBody)
        }, [
          v(l.$slots, "default")
        ], 2)) : c("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  L as default
};
